/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const SELECTED_TYPE = 'SELECTED_TYPE';
export const SELECTED_SEARCH_TYPE = 'SELECTED_SEARCH_TYPE';
export const TABLE_DATA = 'TABLE_DATA';
export const POPUP_TABLE_DATA = 'POPUP_TABLE_DATA';
export const POPUP_FLAG = 'POPUP_FLAG';
export const ERROR_MSGS = 'ERROR_MSGS';
export const SEARCH_LEFT_TABLE_DATA = 'SEARCH_LEFT_TABLE_DATA';
export const RIGHT_TABLE_DATA = 'RIGHT_TABLE_DATA';
export const NAVIGATE_DETAILS = 'NAVIGATE_DETAILS';
export const DRUG_FAMILY_DAETAILS = 'DRUG_FAMILY_DAETAILS';
export const RESET_DRUG_FAMILY_DATA = 'RESET_DRUG_FAMILY_DATA';
export const NDC_DATA = 'NDC_DATA';
export const NDC_NAME = 'NDC_NAME';
